import { isBlank } from './is_blank'
function formatMeta (arr) {
  let newList = []
  arr.forEach((item, index) => {
    newList.push(item.title)
  })
  let metaPermisson = { permission: newList }
  return metaPermisson
}
function formatList (arr) {
  let newList = []
  arr.forEach((item, index) => {
    let cm = item.component
    let newItem = {
      path: item.path,
      name: item.name,
      meta: { permission: [] },
      component: resolve => { require(['@/views/' + cm + '.vue'], resolve) }
    }
    if (item.children && item.children.length > 0) {
      if (item.children[0].type === 0) {
        newItem.children = formatList(item.children)
      } else {
        newItem.meta = formatMeta(item.children)
      }
    }
    if (!isBlank(item.redirect)) {
      newItem.redirect = item.redirect
    }
    newList.push(newItem)
  })
  return newList
}
export const formatRouter = function (routerList) {
  let list = (JSON.parse(JSON.stringify(routerList)))
  // list[0].redirect = list[0].path
  // list[0].path = '/'
  list = formatList(list)
  let prarentItem = {
    path: '/',
    name: 'Contain',
    component: resolve => require(['@/views/container/index.vue'], resolve),
    redirect: list[0].children[0].path,
    children: list
  }
  // console.log(prarentItem)
  return prarentItem
}


// WEBPACK FOOTER //
// ./src/utils/formatRouter.js